import { getAuthAxiosBackend } from "@/helpers/axios"

class IssuersNewIdentificationCardsServices {
    get(id) {
        return getAuthAxiosBackend().get('IssuersNewIdentificationCards/getIssuersNewIdentificationCardsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('IssuersNewIdentificationCards/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('IssuersNewIdentificationCards/addIssuersNewIdentificationCards', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('IssuersNewIdentificationCards/updateIssuersNewIdentificationCards/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('IssuersNewIdentificationCards/restoreIssuersNewIdentificationCards' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('IssuersNewIdentificationCards/softDeleteIssuersNewIdentificationCards/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('IssuersNewIdentificationCards/deleteIssuersNewIdentificationCards/' + id.toString())
    }
}

export default new IssuersNewIdentificationCardsServices()
